import { memo, useState, useEffect, useRef } from 'react';
import { catalogTabsList } from 'configs';

import { PageTitle } from 'containers';
import { Iframe } from 'components';
import clsx from 'clsx';
import { useStyles } from './style';

type Tab = {
  id: string;
  label: string;
};

interface Props {
  currentTab: Tab;
  handleChangeTab: (tab: Tab) => void;
}

const CatalogDetails: React.FC<Props> = ({ currentTab, handleChangeTab }) => {
  const classes = useStyles();
  const ref = useRef<HTMLDivElement>(null);
  const parentRef = useRef<HTMLDivElement>(null);
  const [iframeHeight, setIframeHeight] = useState<number | null>(null);

  useEffect(() => {
    const parentHeight = parentRef?.current?.getBoundingClientRect().height;
    const refHeight = ref.current?.getBoundingClientRect().height;
    let iframeHeight: number | null = null;

    if (typeof refHeight === 'number' && typeof parentHeight === 'number') {
      iframeHeight = refHeight - (parentHeight - 40 - refHeight);
    }

    setIframeHeight(iframeHeight);
  }, []);

  return (
    <div ref={parentRef} className={classes.root}>
      <PageTitle />
      <div ref={ref} className={classes.iframeRoot}>
        <ul className={classes.ul}>
          {catalogTabsList.map((tab) => {
            const isActive = tab.id === currentTab.id;

            return (
              <li
                className={clsx(classes.li, {
                  [classes.active]: isActive,
                })}
                key={tab.id}
                onClick={isActive ? undefined : () => handleChangeTab(tab)}
              >
                {tab.label}
              </li>
            );
          })}
        </ul>
        <div className={classes.container}>
          <Iframe
            url={`/shopify/${currentTab.id}.html`}
            height={iframeHeight}
            scrolling="auto"
          />
        </div>
      </div>
    </div>
  );
};

export default memo(CatalogDetails);
